import { dayjsInstance } from '@/lib/Dayjs'
import {
  PORTONE_REDIRECT_QUERY_KEYS,
  PORTONE_VIRTUAL_ACCOUNT_DUE_DAYS,
} from '@/lib/PortOne/portOne.constants'
import type { IPortOnePaymentResult } from '@/lib/PortOne/portOne.types'

/** 무통장 입금 기한 — N일 후 자정 (SDK 허용 형식: YYYYMMDDHHmmss) */
export const getVirtualAccountDueDate = (days = PORTONE_VIRTUAL_ACCOUNT_DUE_DAYS) =>
  dayjsInstance().add(days, 'day').endOf('date').format('YYYYMMDDHHmmss')

/**
 * URL 쿼리에서 PortOne redirect 결과 추출 (없으면 null)
 * - V2: paymentId, code, message
 * - V1: merchant_uid(= prepare paymentId), imp_success | success, error_code, error_msg
 */
export const parsePortOneRedirectResult = (search: string): IPortOnePaymentResult | null => {
  const params = new URLSearchParams(search)

  const paymentId = params.get('paymentId')
  if (paymentId) {
    return {
      paymentId,
      code: params.get('code'),
      message: params.get('message'),
    }
  }

  const merchantUid = params.get('merchant_uid')
  if (merchantUid) {
    const success = params.get('imp_success') ?? params.get('success')
    const errorCode = params.get('error_code')
    const isFailed = success === 'false' || !!errorCode
    return {
      paymentId: merchantUid,
      code: isFailed ? errorCode || 'FAILED' : null,
      message: params.get('error_msg'),
    }
  }

  return null
}

/** PortOne redirect 쿼리 제거 후 history 교체 */
export const clearPortOneRedirectQuery = () => {
  const params = new URLSearchParams(window.location.search)
  PORTONE_REDIRECT_QUERY_KEYS.forEach(key => params.delete(key))
  const qs = params.toString()
  window.history.replaceState({}, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`)
}

/** 현재 페이지 URL (query 제외) — 모바일 redirect 복귀 기본값 */
export const getCurrentPageUrl = () => `${window.location.origin}${window.location.pathname}`
